import { atom } from "jotai";

export const drawerAtom = atom(false)